<template>
  <section>
    <h1 class="text-h3 mb-8">
      Alerts
    </h1>
    <v-sheet
      class="mb-4 px-6 py-4"
      outlined
      rounded
    >
      <div class="d-flex justify-space-between">
        <v-checkbox
          v-model="icon"
          label="Icon"
        />
        <v-checkbox
          v-model="dense"
          label="Dense"
        />
        <v-checkbox
          v-model="outlined"
          label="Outlined"
        />
        <v-checkbox
          v-model="text"
          label="Text"
        />
        <v-checkbox
          v-model="prominent"
          label="Prominent"
        />
      </div>
      <v-alert
        v-for="type in types"
        :key="type"
        :icon="icon"
        :type="type"
        :dense="dense"
        :outlined="outlined"
        :text="text"
        :prominent="prominent"
      >
        I'm an alert with a <strong>type</strong> of {{ type }}.
      </v-alert>
    </v-sheet>
    <h2 class="text-h4 mb-4">
      Further reading
    </h2>
    <external-link href="https://vuetifyjs.com/en/components/alerts/">
      <strong>Alerts</strong>
    </external-link>
  </section>
</template>

<script>
export default {
  name: 'ComponentsAlerts',
  data: () => ({
    types: ['info', 'success', 'warning', 'error'],
    icon: true,
    dense: false,
    outlined: false,
    text: false,
    prominent: false
  })
}
</script>
